/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BasePercentiles {
    _10 = '10',
    _25 = '25',
    _33 = '33',
    _50 = '50',
    _60 = '60',
    _62P5 = '62p5',
    _65 = '65',
    _66 = '66',
    _70 = '70',
    _75 = '75',
    _80 = '80',
    _90 = '90',
    _95 = '95',
    CP1 = 'CP1',
}
